module.exports = __webpack_public_path__ + "static/media/IconMapFav.a2aded8a.svg";